import { Country } from '@/types/region'

export const USA_COUNTRY: Country = {
  iso2: 'us',
  name: 'United States'
}

export const CANADA_COUNTRY: Country = {
  iso2: 'ca',
  name: 'Canada'
}

const UNSPECIFIED_COUNTRY: Country = {
  iso2: 'zz',
  name: 'Unspecified'
}

export const COUNTRIES: Country[] = [
  USA_COUNTRY,
  CANADA_COUNTRY,
  UNSPECIFIED_COUNTRY,
  {
    iso2: 'ad',
    name: 'Andorra'
  },
  {
    iso2: 'ae',
    name: 'United Arab Emirates'
  },
  {
    iso2: 'af',
    name: 'Afghanistan'
  },
  {
    iso2: 'ag',
    name: 'Antigua and Barbuda'
  },
  {
    iso2: 'ai',
    name: 'Anguilla'
  },
  {
    iso2: 'al',
    name: 'Albania'
  },
  {
    iso2: 'am',
    name: 'Armenia'
  },
  {
    iso2: 'ao',
    name: 'Angola'
  },
  {
    iso2: 'aq',
    name: 'Antarctica'
  },
  {
    iso2: 'ar',
    name: 'Argentina'
  },
  {
    iso2: 'as',
    name: 'American Samoa'
  },
  {
    iso2: 'at',
    name: 'Austria'
  },
  {
    iso2: 'au',
    name: 'Australia'
  },
  {
    iso2: 'aw',
    name: 'Aruba'
  },
  {
    iso2: 'ax',
    name: 'Åland'
  },
  {
    iso2: 'az',
    name: 'Azerbaijan'
  },
  {
    iso2: 'ba',
    name: 'Bosnia and Herzegovina'
  },
  {
    iso2: 'bb',
    name: 'Barbados'
  },
  {
    iso2: 'bd',
    name: 'Bangladesh'
  },
  {
    iso2: 'be',
    name: 'Belgium'
  },
  {
    iso2: 'bf',
    name: 'Burkina Faso'
  },
  {
    iso2: 'bg',
    name: 'Bulgaria'
  },
  {
    iso2: 'bh',
    name: 'Bahrain'
  },
  {
    iso2: 'bi',
    name: 'Burundi'
  },
  {
    iso2: 'bj',
    name: 'Benin'
  },
  {
    iso2: 'bl',
    name: 'Saint Barthélemy'
  },
  {
    iso2: 'bm',
    name: 'Bermuda'
  },
  {
    iso2: 'bn',
    name: 'Brunei'
  },
  {
    iso2: 'bo',
    name: 'Bolivia'
  },
  {
    iso2: 'bq',
    name: 'Bonaire'
  },
  {
    iso2: 'br',
    name: 'Brazil'
  },
  {
    iso2: 'bs',
    name: 'Bahamas'
  },
  {
    iso2: 'bt',
    name: 'Bhutan'
  },
  {
    iso2: 'bv',
    name: 'Bouvet Island'
  },
  {
    iso2: 'bw',
    name: 'Botswana'
  },
  {
    iso2: 'by',
    name: 'Belarus'
  },
  {
    iso2: 'bz',
    name: 'Belize'
  },
  {
    iso2: 'cc',
    name: 'Cocos [Keeling] Islands'
  },
  {
    iso2: 'cd',
    name: 'Democratic Republic of the Congo'
  },
  {
    iso2: 'cf',
    name: 'Central African Republic'
  },
  {
    iso2: 'cg',
    name: 'Republic of the Congo'
  },
  {
    iso2: 'ch',
    name: 'Switzerland'
  },
  {
    iso2: 'ci',
    name: 'Ivory Coast'
  },
  {
    iso2: 'ck',
    name: 'Cook Islands'
  },
  {
    iso2: 'cl',
    name: 'Chile'
  },
  {
    iso2: 'cm',
    name: 'Cameroon'
  },
  {
    iso2: 'cn',
    name: 'China'
  },
  {
    iso2: 'co',
    name: 'Colombia'
  },
  {
    iso2: 'cr',
    name: 'Costa Rica'
  },
  {
    iso2: 'cu',
    name: 'Cuba'
  },
  {
    iso2: 'cv',
    name: 'Cape Verde'
  },
  {
    iso2: 'cw',
    name: 'Curacao'
  },
  {
    iso2: 'cx',
    name: 'Christmas Island'
  },
  {
    iso2: 'cy',
    name: 'Cyprus'
  },
  {
    iso2: 'cz',
    name: 'Czech Republic'
  },
  {
    iso2: 'de',
    name: 'Germany'
  },
  {
    iso2: 'dj',
    name: 'Djibouti'
  },
  {
    iso2: 'dk',
    name: 'Denmark'
  },
  {
    iso2: 'dm',
    name: 'Dominica'
  },
  {
    iso2: 'do',
    name: 'Dominican Republic'
  },
  {
    iso2: 'dz',
    name: 'Algeria'
  },
  {
    iso2: 'ec',
    name: 'Ecuador'
  },
  {
    iso2: 'ee',
    name: 'Estonia'
  },
  {
    iso2: 'eg',
    name: 'Egypt'
  },
  {
    iso2: 'eh',
    name: 'Western Sahara'
  },
  {
    iso2: 'er',
    name: 'Eritrea'
  },
  {
    iso2: 'es',
    name: 'Spain'
  },
  {
    iso2: 'et',
    name: 'Ethiopia'
  },
  {
    iso2: 'fi',
    name: 'Finland'
  },
  {
    iso2: 'fj',
    name: 'Fiji'
  },
  {
    iso2: 'fk',
    name: 'Falkland Islands'
  },
  {
    iso2: 'fm',
    name: 'Micronesia'
  },
  {
    iso2: 'fo',
    name: 'Faroe Islands'
  },
  {
    iso2: 'fr',
    name: 'France'
  },
  {
    iso2: 'ga',
    name: 'Gabon'
  },
  {
    iso2: 'gb',
    name: 'United Kingdom'
  },
  {
    iso2: 'gd',
    name: 'Grenada'
  },
  {
    iso2: 'ge',
    name: 'Georgia'
  },
  {
    iso2: 'gf',
    name: 'French Guiana'
  },
  {
    iso2: 'gg',
    name: 'Guernsey'
  },
  {
    iso2: 'gh',
    name: 'Ghana'
  },
  {
    iso2: 'gi',
    name: 'Gibraltar'
  },
  {
    iso2: 'gl',
    name: 'Greenland'
  },
  {
    iso2: 'gm',
    name: 'Gambia'
  },
  {
    iso2: 'gn',
    name: 'Guinea'
  },
  {
    iso2: 'gp',
    name: 'Guadeloupe'
  },
  {
    iso2: 'gq',
    name: 'Equatorial Guinea'
  },
  {
    iso2: 'gr',
    name: 'Greece'
  },
  {
    iso2: 'gs',
    name: 'South Georgia and the South Sandwich Islands'
  },
  {
    iso2: 'gt',
    name: 'Guatemala'
  },
  {
    iso2: 'gu',
    name: 'Guam'
  },
  {
    iso2: 'gw',
    name: 'Guinea-Bissau'
  },
  {
    iso2: 'gy',
    name: 'Guyana'
  },
  {
    iso2: 'hk',
    name: 'Hong Kong'
  },
  {
    iso2: 'hm',
    name: 'Heard Island and McDonald Islands'
  },
  {
    iso2: 'hn',
    name: 'Honduras'
  },
  {
    iso2: 'hr',
    name: 'Croatia'
  },
  {
    iso2: 'ht',
    name: 'Haiti'
  },
  {
    iso2: 'hu',
    name: 'Hungary'
  },
  {
    iso2: 'id',
    name: 'Indonesia'
  },
  {
    iso2: 'ie',
    name: 'Ireland'
  },
  {
    iso2: 'il',
    name: 'Israel'
  },
  {
    iso2: 'im',
    name: 'Isle of Man'
  },
  {
    iso2: 'in',
    name: 'India'
  },
  {
    iso2: 'io',
    name: 'British Indian Ocean Territory'
  },
  {
    iso2: 'iq',
    name: 'Iraq'
  },
  {
    iso2: 'ir',
    name: 'Iran'
  },
  {
    iso2: 'is',
    name: 'Iceland'
  },
  {
    iso2: 'it',
    name: 'Italy'
  },
  {
    iso2: 'je',
    name: 'Jersey'
  },
  {
    iso2: 'jm',
    name: 'Jamaica'
  },
  {
    iso2: 'jo',
    name: 'Jordan'
  },
  {
    iso2: 'jp',
    name: 'Japan'
  },
  {
    iso2: 'ke',
    name: 'Kenya'
  },
  {
    iso2: 'kg',
    name: 'Kyrgyzstan'
  },
  {
    iso2: 'kh',
    name: 'Cambodia'
  },
  {
    iso2: 'ki',
    name: 'Kiribati'
  },
  {
    iso2: 'km',
    name: 'Comoros'
  },
  {
    iso2: 'kn',
    name: 'Saint Kitts and Nevis'
  },
  {
    iso2: 'kp',
    name: 'North Korea'
  },
  {
    iso2: 'kr',
    name: 'South Korea'
  },
  {
    iso2: 'kw',
    name: 'Kuwait'
  },
  {
    iso2: 'ky',
    name: 'Cayman Islands'
  },
  {
    iso2: 'kz',
    name: 'Kazakhstan'
  },
  {
    iso2: 'la',
    name: 'Laos'
  },
  {
    iso2: 'lb',
    name: 'Lebanon'
  },
  {
    iso2: 'lc',
    name: 'Saint Lucia'
  },
  {
    iso2: 'li',
    name: 'Liechtenstein'
  },
  {
    iso2: 'lk',
    name: 'Sri Lanka'
  },
  {
    iso2: 'lr',
    name: 'Liberia'
  },
  {
    iso2: 'ls',
    name: 'Lesotho'
  },
  {
    iso2: 'lt',
    name: 'Lithuania'
  },
  {
    iso2: 'lu',
    name: 'Luxembourg'
  },
  {
    iso2: 'lv',
    name: 'Latvia'
  },
  {
    iso2: 'ly',
    name: 'Libya'
  },
  {
    iso2: 'ma',
    name: 'Morocco'
  },
  {
    iso2: 'mc',
    name: 'Monaco'
  },
  {
    iso2: 'md',
    name: 'Moldova'
  },
  {
    iso2: 'me',
    name: 'Montenegro'
  },
  {
    iso2: 'mf',
    name: 'Saint Martin'
  },
  {
    iso2: 'mg',
    name: 'Madagascar'
  },
  {
    iso2: 'mh',
    name: 'Marshall Islands'
  },
  {
    iso2: 'mk',
    name: 'Macedonia'
  },
  {
    iso2: 'ml',
    name: 'Mali'
  },
  {
    iso2: 'mm',
    name: 'Myanmar [Burma]'
  },
  {
    iso2: 'mn',
    name: 'Mongolia'
  },
  {
    iso2: 'mo',
    name: 'Macao'
  },
  {
    iso2: 'mp',
    name: 'Northern Mariana Islands'
  },
  {
    iso2: 'mq',
    name: 'Martinique'
  },
  {
    iso2: 'mr',
    name: 'Mauritania'
  },
  {
    iso2: 'ms',
    name: 'Montserrat'
  },
  {
    iso2: 'mt',
    name: 'Malta'
  },
  {
    iso2: 'mu',
    name: 'Mauritius'
  },
  {
    iso2: 'mv',
    name: 'Maldives'
  },
  {
    iso2: 'mw',
    name: 'Malawi'
  },
  {
    iso2: 'mx',
    name: 'Mexico'
  },
  {
    iso2: 'my',
    name: 'Malaysia'
  },
  {
    iso2: 'mz',
    name: 'Mozambique'
  },
  {
    iso2: 'na',
    name: 'Namibia'
  },
  {
    iso2: 'nc',
    name: 'New Caledonia'
  },
  {
    iso2: 'ne',
    name: 'Niger'
  },
  {
    iso2: 'nf',
    name: 'Norfolk Island'
  },
  {
    iso2: 'ng',
    name: 'Nigeria'
  },
  {
    iso2: 'ni',
    name: 'Nicaragua'
  },
  {
    iso2: 'nl',
    name: 'Netherlands'
  },
  {
    iso2: 'no',
    name: 'Norway'
  },
  {
    iso2: 'np',
    name: 'Nepal'
  },
  {
    iso2: 'nr',
    name: 'Nauru'
  },
  {
    iso2: 'nu',
    name: 'Niue'
  },
  {
    iso2: 'nz',
    name: 'New Zealand'
  },
  {
    iso2: 'om',
    name: 'Oman'
  },
  {
    iso2: 'pa',
    name: 'Panama'
  },
  {
    iso2: 'pe',
    name: 'Peru'
  },
  {
    iso2: 'pf',
    name: 'French Polynesia'
  },
  {
    iso2: 'pg',
    name: 'Papua New Guinea'
  },
  {
    iso2: 'ph',
    name: 'Philippines'
  },
  {
    iso2: 'pk',
    name: 'Pakistan'
  },
  {
    iso2: 'pl',
    name: 'Poland'
  },
  {
    iso2: 'pm',
    name: 'Saint Pierre and Miquelon'
  },
  {
    iso2: 'pn',
    name: 'Pitcairn Islands'
  },
  {
    iso2: 'pr',
    name: 'Puerto Rico'
  },
  {
    iso2: 'ps',
    name: 'Palestine'
  },
  {
    iso2: 'pt',
    name: 'Portugal'
  },
  {
    iso2: 'pw',
    name: 'Palau'
  },
  {
    iso2: 'py',
    name: 'Paraguay'
  },
  {
    iso2: 'qa',
    name: 'Qatar'
  },
  {
    iso2: 're',
    name: 'Réunion'
  },
  {
    iso2: 'ro',
    name: 'Romania'
  },
  {
    iso2: 'rs',
    name: 'Serbia'
  },
  {
    iso2: 'ru',
    name: 'Russia'
  },
  {
    iso2: 'rw',
    name: 'Rwanda'
  },
  {
    iso2: 'sa',
    name: 'Saudi Arabia'
  },
  {
    iso2: 'sb',
    name: 'Solomon Islands'
  },
  {
    iso2: 'sc',
    name: 'Seychelles'
  },
  {
    iso2: 'sd',
    name: 'Sudan'
  },
  {
    iso2: 'se',
    name: 'Sweden'
  },
  {
    iso2: 'sg',
    name: 'Singapore'
  },
  {
    iso2: 'sh',
    name: 'Saint Helena'
  },
  {
    iso2: 'si',
    name: 'Slovenia'
  },
  {
    iso2: 'sj',
    name: 'Svalbard and Jan Mayen'
  },
  {
    iso2: 'sk',
    name: 'Slovakia'
  },
  {
    iso2: 'sl',
    name: 'Sierra Leone'
  },
  {
    iso2: 'sm',
    name: 'San Marino'
  },
  {
    iso2: 'sn',
    name: 'Senegal'
  },
  {
    iso2: 'so',
    name: 'Somalia'
  },
  {
    iso2: 'sr',
    name: 'Suriname'
  },
  {
    iso2: 'ss',
    name: 'South Sudan'
  },
  {
    iso2: 'st',
    name: 'São Tomé and Príncipe'
  },
  {
    iso2: 'sv',
    name: 'El Salvador'
  },
  {
    iso2: 'sx',
    name: 'Sint Maarten'
  },
  {
    iso2: 'sy',
    name: 'Syria'
  },
  {
    iso2: 'sz',
    name: 'Swaziland'
  },
  {
    iso2: 'tc',
    name: 'Turks and Caicos Islands'
  },
  {
    iso2: 'td',
    name: 'Chad'
  },
  {
    iso2: 'tf',
    name: 'French Southern Territories'
  },
  {
    iso2: 'tg',
    name: 'Togo'
  },
  {
    iso2: 'th',
    name: 'Thailand'
  },
  {
    iso2: 'tj',
    name: 'Tajikistan'
  },
  {
    iso2: 'tk',
    name: 'Tokelau'
  },
  {
    iso2: 'tl',
    name: 'East Timor'
  },
  {
    iso2: 'tm',
    name: 'Turkmenistan'
  },
  {
    iso2: 'tn',
    name: 'Tunisia'
  },
  {
    iso2: 'to',
    name: 'Tonga'
  },
  {
    iso2: 'tr',
    name: 'Turkey'
  },
  {
    iso2: 'tt',
    name: 'Trinidad and Tobago'
  },
  {
    iso2: 'tv',
    name: 'Tuvalu'
  },
  {
    iso2: 'tw',
    name: 'Taiwan'
  },
  {
    iso2: 'tz',
    name: 'Tanzania'
  },
  {
    iso2: 'ua',
    name: 'Ukraine'
  },
  {
    iso2: 'ug',
    name: 'Uganda'
  },
  {
    iso2: 'um',
    name: 'U.S. Minor Outlying Islands'
  },
  {
    iso2: 'uy',
    name: 'Uruguay'
  },
  {
    iso2: 'uz',
    name: 'Uzbekistan'
  },
  {
    iso2: 'va',
    name: 'Vatican City'
  },
  {
    iso2: 'vc',
    name: 'Saint Vincent and the Grenadines'
  },
  {
    iso2: 've',
    name: 'Venezuela'
  },
  {
    iso2: 'vg',
    name: 'British Virgin Islands'
  },
  {
    iso2: 'vi',
    name: 'U.S. Virgin Islands'
  },
  {
    iso2: 'vn',
    name: 'Vietnam'
  },
  {
    iso2: 'vu',
    name: 'Vanuatu'
  },
  {
    iso2: 'wf',
    name: 'Wallis and Futuna'
  },
  {
    iso2: 'ws',
    name: 'Samoa'
  },
  {
    iso2: 'xk',
    name: 'Kosovo'
  },
  {
    iso2: 'ye',
    name: 'Yemen'
  },
  {
    iso2: 'yt',
    name: 'Mayotte'
  },
  {
    iso2: 'za',
    name: 'South Africa'
  },
  {
    iso2: 'zm',
    name: 'Zambia'
  },
  {
    iso2: 'zw',
    name: 'Zimbabwe'
  }
]
